export default "__VITE_ASSET__B724Q0DF__"